define("checkout/components/interval", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! NOTE: @isHorizontal can be used to adjust the layout for Seamless Checkout }}
  <div class={{if @isHorizontal "tPF--checkout__option"}}>
    <div
      class="tCH--option qa--checkout__interval--yearly
        {{if @selectedSubscriptionPlan.isYearly 'is--checked tCH--text--border'}}"
      data-test-id="yearly"
      {{on "click" (action @onInterval @yearlyPlan)}}
    >
      <div class="tCH--option__checkbox">
        {{svg-jar "check" class="o--icon tCH--option__checkboxIcon"}}
      </div>
      <span class="qa--checkout__interval--price">{{format-currency @yearlyPlan.amount}}</span>
      <br />
      <span class="qa--checkout__interval--text">
        {{#if @yearlyLabel}}
          {{@yearlyLabel}}
        {{else if @isHorizontal}}
          {{t "plans.checkout.plan.yearly_short"}}
        {{else}}
          {{t "plans.checkout.plan.yearly"}}
        {{/if}}
      </span>
      <div class="tCH--option__badge qa--checkout__interval--discount">
        {{t "plans.checkout.plan.yearly_discount" amount=this.yearlyDiscountPercent}}
      </div>
    </div>
  
    {{#if @displayMonthly}}
      <div
        class="tCH--option qa--checkout__interval--monthly
          {{if @selectedSubscriptionPlan.isMonthly 'is--checked tCH--text--border'}}"
        data-test-id="monthly"
        {{on "click" (action @onInterval @monthlyPlan)}}
      >
        <div class="tCH--option__checkbox">
          {{svg-jar "check" class="o--icon tCH--option__checkboxIcon"}}
        </div>
        <span class="qa--checkout__interval--price">{{format-currency @monthlyPlan.amount}}</span>
        <br />
        <span class="qa--checkout__interval--text">
          {{#if @monthlyLabel}}
            {{@monthlyLabel}}
          {{else}}
            {{t "plans.checkout.plan.monthly"}}
          {{/if}}
        </span>
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "2bKw6YSe",
    "block": "[[[10,0],[15,0,[52,[30,1],\"tPF--checkout__option\"]],[12],[1,\"\\n  \"],[11,0],[16,0,[29,[\"tCH--option qa--checkout__interval--yearly\\n      \",[52,[30,2,[\"isYearly\"]],\"is--checked tCH--text--border\"]]]],[24,\"data-test-id\",\"yearly\"],[4,[38,1],[\"click\",[28,[37,2],[[30,0],[30,3],[30,4]],null]],null],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCH--option__checkbox\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon tCH--option__checkboxIcon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"qa--checkout__interval--price\"],[12],[1,[28,[35,4],[[30,4,[\"amount\"]]],null]],[13],[1,\"\\n    \"],[10,\"br\"],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"qa--checkout__interval--text\"],[12],[1,\"\\n\"],[41,[30,5],[[[1,\"        \"],[1,[30,5]],[1,\"\\n\"]],[]],[[[41,[30,1],[[[1,\"        \"],[1,[28,[35,5],[\"plans.checkout.plan.yearly_short\"],null]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,5],[\"plans.checkout.plan.yearly\"],null]],[1,\"\\n      \"]],[]]]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCH--option__badge qa--checkout__interval--discount\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"plans.checkout.plan.yearly_discount\"],[[\"amount\"],[[30,0,[\"yearlyDiscountPercent\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,6],[[[1,\"    \"],[11,0],[16,0,[29,[\"tCH--option qa--checkout__interval--monthly\\n        \",[52,[30,2,[\"isMonthly\"]],\"is--checked tCH--text--border\"]]]],[24,\"data-test-id\",\"monthly\"],[4,[38,1],[\"click\",[28,[37,2],[[30,0],[30,3],[30,7]],null]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCH--option__checkbox\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon tCH--option__checkboxIcon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"qa--checkout__interval--price\"],[12],[1,[28,[35,4],[[30,7,[\"amount\"]]],null]],[13],[1,\"\\n      \"],[10,\"br\"],[12],[13],[1,\"\\n      \"],[10,1],[14,0,\"qa--checkout__interval--text\"],[12],[1,\"\\n\"],[41,[30,8],[[[1,\"          \"],[1,[30,8]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,5],[\"plans.checkout.plan.monthly\"],null]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@isHorizontal\",\"@selectedSubscriptionPlan\",\"@onInterval\",\"@yearlyPlan\",\"@yearlyLabel\",\"@displayMonthly\",\"@monthlyPlan\",\"@monthlyLabel\"],false,[\"if\",\"on\",\"action\",\"svg-jar\",\"format-currency\",\"t\"]]",
    "moduleName": "checkout/components/interval.hbs",
    "isStrictMode": false
  });
  class IntervalComponent extends _component2.default {
    get yearlyDiscountPercent() {
      const {
        monthlyPlan,
        yearlyPlan
      } = this.args;
      const discount = monthlyPlan.amount * 12 - yearlyPlan.amount;
      const discountPercent = discount / (monthlyPlan.amount * 12) * 100;
      return discountPercent.toFixed(0);
    }
  }
  _exports.default = IntervalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, IntervalComponent);
});